<template>
    <PanelV2
      type="w7"
      title="Grow your business with cashless payment acceptance!"
      @nextClick="commitData()"
    >
      <template v-slot:content-solt>
        <Digital :digitalData="formData" @checkboxClick="updateCheckedData" digitalType="pos" />
      </template>
    </PanelV2>
</template>

<script>
  import Digital from "./common/Digital.vue";
  import API from "@/api";
  import { getUrlParam } from "../../plugins/utils";

  export default {
    name: 'SolePropC',
    pRouter: 'SolePropB',
    components: {
      Digital,
    },
    data() {
      return {
        formData: null
      }
    },
    methods: {
      updateCheckedData(data) {
        this.formData = data;
      },
      commitData() {
        if(this.formData.every(val => val.chooseFlag == '2') && getUrlParam('isSelected') === 'false') {
            this.$confirm({
                tip: true,
                mesg: 'You may choose 1 or more products from the digital/physical store options.',
            })
            return
        }
        const data = this.formatCommitData({physicalPaymentList: this.formData})

        API.addBdoProcess({
          ...data
        }).then(res => {
          if (res.success) {
            this.toNext()
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>
